import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/system'
import { FONTS } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  containerField: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        width: 334,

        marginTop: theme.spacing(1),
      },

      [theme.breakpoints.up('tablet')]: {
        width: 380,
      },
    },
  },
  InputProps: {
    '&&': {
      fontWeight: '700',
      color: theme.palette.custom.darkBlue2,
      zIndex: 1,
      '&:-webkit-autofill': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },
      '&:-webkit-autofill:hover': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },
      '&:-webkit-autofill:focus': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },
      '&:-webkit-autofill:active': {
        transition: 'background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s',
        transitionDelay: 'background-color 5000s, color 5000s',
      },

      [theme.breakpoints.down('tablet')]: {
        height: 23,

        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        height: 35,

        fontSize: FONTS.SIZES.m,
      },
    },
  },
  TextInput: {
    '&&': {
      [`& fieldset`]: {
        borderWidth: 0,

        [theme.breakpoints.down('tablet')]: {
          borderRadius: 10,

          background: theme.palette.custom.grey,
        },
        [theme.breakpoints.up('tablet')]: {
          borderRadius: 30,

          background: theme.palette.custom.secondary,
        },
      },
      '& label.Mui-focused': {
        color: theme.palette.custom.white,
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: theme.palette.custom.primary,
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: theme.palette.custom.primary,
        },
        '&:hover fieldset': {
          borderColor: theme.palette.custom.primary,
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.custom.primary,
        },
      },
      '& .MuiFormHelperText-root': {
        color: 'red',
      },

      [theme.breakpoints.down('tablet')]: {
        width: 334,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 380,
      },
    },
  },
  TextInputLabel: {
    '&&': {
      [theme.breakpoints.up('tablet')]: {
        display: 'none',
      },

      color: theme.palette.custom.darkBlue2,
      fontFamily: FONTS.FAMILIES.notoSans,
      fontWeight: 700,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.25,

      marginBottom: theme.spacing(1),
    },
  },
  textSignUp: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1.35,

      [theme.breakpoints.down('laptop')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: '500',
        color: theme.palette.custom.darkBlue2,
      },
      [theme.breakpoints.up('laptop')]: {
        fontWeight: '500',
        fontSize: FONTS.SIZES.m,
        color: theme.palette.custom.grey2,
      },
    },
  },
}))

export { useStyles }
